// The SCSS layout numbers the JS needs, copied here and nowhere else in the JS. Each one names what it
// copies, and tests/unit/layoutTokens.spec.js compiles the SCSS and fails when a copy no longer
// matches it.

// $dashboard-header-height in _variables.scss: the fixed header's height, in px.
export const DASHBOARD_HEADER_HEIGHT = 55

// Where the SCSS turns the sidebar into a drawer (the `sidebar-drawer` mixin in _layout.scss): a
// phone's width, a short screen, which a phone on its side is, or a touch screen narrower than lg,
// which a tablet upright is.
export const DRAWER_LAYOUT_QUERY = '(max-width: 767.98px), (max-height: 499.98px), (pointer: coarse) and (max-width: 991.98px)'
